<div class="boxWhite" *ngIf="viaje">
  <h4>
    INICIAR VIAJE
    <span>¿Estás seguro que quieres iniciar este viaje?</span>
  </h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="headInfo bgGreen">
    <div class="servicio">
      <span>SERVICIO</span>
      <h4>{{ viaje.servicio }}</h4>
    </div>
    <div class="info">
      <div class="item">
        <span>ID VIAJE</span>
        <p>{{ viaje.viajeCodigo }}</p>
      </div>
      <div class="item">
        <span>INICIO</span>
        <p>{{ viaje.fechahoraInicio | date:'HH:mm' }}</p>
      </div>
      <div class="item">
        <span>NOMBRE CB</span>
        <p>{{ viaje.conductor ? (viaje.conductor.nombres + ' ' + viaje.conductor.apellidoPaterno) : '--' }}</p>
      </div>
      <div class="item">
        <span>PATENTE</span>
        <p>{{ viaje.movil?.patente || '--' }}</p>
      </div>
    </div>

    <div class="content doble">
      <div class="item">
        <span>% COMBUSTIBLE/BATERÍA</span>
        <input type="range" class="form-range" [(ngModel)]="combustiblePorcentaje" min="0" max="100" step="1">
        <p class="text-center mt-2">{{ combustiblePorcentaje }}%</p>
      </div>
      <button *ngIf="tienePermisoIniciarViaje()" class="btn btnWhite w-100" [disabled]="enviando" (click)="iniciarViaje()">
        <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" style="color: var(--orange);"></span>
        <img src="assets/img/icoInicarViaje.svg" alt="">INICIAR VIAJE
      </button>
    </div>
  </div>

</div>
